import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  AdCarouselDetails: [],
  isLoadingCard: false,
  errorCard: "",
  isLoadingCarousel: false,
  errorCarousel: ""
};
const adCarouselSlice = createSlice({
  name: "adCarousel",
  initialState,
  reducers: {
    adCarouselDataRequest: state => {
      state.isLoadingCarousel = true;
    },
    getAdCarouselDataSuccess: (state, action) => {
      state.isLoadingCarousel = false;
      state.errorCarousel = "";
      state.AdCarouselDetails = action.payload;
    },
    getAdCarouselDataFailure: (state, action) => {
      state.errorCarousel = action.payload;
      state.isLoadingCarousel = false;
    }
  }
});
export const {
  adCarouselDataRequest,
  getAdCarouselDataSuccess,
  getAdCarouselDataFailure
} = adCarouselSlice.actions;
export default adCarouselSlice.reducer;